module.exports = __webpack_public_path__ + "3b9ae8a46c787bf960d6c501e9e68234.webp";